import React from 'react';
import { KoobEnableableSection } from '@koob/ui';
import { PrivateModeKindEnum } from '@koob/enums';
import { useTranslation } from 'react-i18next';
import { bookingsListPath } from '../../List/BookingsHeader';

// A DMC hides a message or document from its client: shown on a client's
// booking (Clients' bookings), and to hotel keepers.
export default function PrivateModeSwitch({
  booking,
  privateMode,
  setPrivateMode,
  kind = PrivateModeKindEnum.DMC,
}) {
  const { t } = useTranslation('bookings');
  const isHotelKeeper = kind === PrivateModeKindEnum.HOTEL_KEEPER;
  const isClientBooking =
    Boolean(booking) &&
    bookingsListPath(booking) === '/bookings/partner-bookings';

  return isHotelKeeper || isClientBooking ? (
    <div className="mb-5">
      <KoobEnableableSection
        title={t('private.title')}
        description={t(
          isHotelKeeper
            ? 'private.hotelKeeperDescription'
            : 'private.description',
        )}
        checked={privateMode}
        onCheckedChange={setPrivateMode}
        open={false}
      />
    </div>
  ) : null;
}
